import { convertNumber } from "utils"

type HeaderCOAType = {
  coa_name: string
  coa_enum: string
  coa_level: number
  label: string
  balance: number[]
  header_level: 1 | 2 | 3
  summary: number
  average: number
}
export const HeaderCOA = (props: HeaderCOAType) => {
  const background = props?.balance?.some((val) => val < 0) ? "bg-[#adadad] text-[#BF092F]" : "bg-[#adadad] dark:text-black";

  return (
    <>
      {props?.coa_name?.toUpperCase() === props?.coa_enum && (
        <tr key="gross-profit">
          <td className={background}>
            <span
              className="font-bold"
              style={{ marginLeft: (props?.coa_level - 1) * 24 }}
            >
              {props?.label}
            </span>
          </td>

          {props?.balance?.length! > 0 ? (
            props?.balance?.map((value, index) => {
              const isNegative = value < 0;
              const cellBg = isNegative ? "bg-[#adadad] text-[#BF092F]" : "bg-[#adadad] dark:text-black";

              return (
                <td
                  key={`gross-${index}`}
                  className={`text-right ${cellBg} ${[3].includes(props?.header_level) ? "font-normal" : "font-bold"}`}>
                  {convertNumber(value || 0).intoCurrency}
                </td>
              )
            })
          ) : (
            <td className={`text-right ${background}`}>0</td>
          )}

          <td
            key={props?.summary}
            className={`text-right ${background} ${[3].includes(props?.header_level) ? "font-normal" : "font-bold"}`}>
            {convertNumber(props?.summary).intoCurrency}
          </td>
    
          <td
            key={props?.average}
            className={`text-right ${background} ${[3].includes(props?.header_level) ? "font-normal" : "font-bold"}`}>
            {convertNumber(props?.average).intoCurrency}
          </td>
        </tr>
      )}
    </>
  )
}